import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import { personnelFeatureKey } from '../key';
import type { PersonnelListQueryFilter } from './types';

type PersonnelListQueryType = GenericListQueryKey<PersonnelListQueryFilter>;

export const getPersonnelListQueryKey = (params: PersonnelListQueryType) =>
  generateListQueryKey({
    prefix: personnelFeatureKey,
  })(params);

export const getPersonnelInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getPersonnelListQueryKey,
});
